export default __webpack_public_path__ + "static/media/JanhviJ.6ededab5.jpg";